import { useTheme } from 'foundations-theming/utils';
import ColorPicker from './ColorPicker';
import { List } from 'foundations-components/transitional/components/List';
import { ColorInput } from 'foundations-components/transitional/components/ColorInput';
import { BRAND_COLORS, LINEAR_GRADIENTS } from '../constants/Colors';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ColorPalette({
  color,
  onChange
}) {
  const trellisTheme = useTheme();
  return /*#__PURE__*/_jsx(List, {
    marginBlockStart: "600",
    wrapChildren: true,
    children: /*#__PURE__*/_jsxs(Flex, {
      flexWrap: "wrap",
      alignItems: "center",
      flexDirection: "row",
      marginBlockEnd: "600",
      children: [/*#__PURE__*/_jsx(View, {
        borderInlineEndStyle: "solid",
        borderInlineEndWidth: "100",
        borderInlineColor: "icon-secondary-disabled",
        children: /*#__PURE__*/_jsx(Flex, {
          flexDirection: "row",
          marginBlockStart: "100",
          children: BRAND_COLORS.map(c => /*#__PURE__*/_jsx(ColorPicker, {
            onClick: () => onChange(c),
            selected: color === c,
            gradient: LINEAR_GRADIENTS[c]
          }, c))
        })
      }), /*#__PURE__*/_jsx(ColorInput, {
        defaultColor: trellisTheme.color['do-not-use-norman'],
        color: color,
        onColorChange: ({
          target: {
            value
          }
        }) => {
          onChange(value);
        },
        use: "on-dark",
        swatchProps: {
          size: 18
        },
        marginInlineStart: "300",
        marginBlockStart: "100"
      })]
    })
  });
}